import { Fragment } from "react";
import Alert from "../../../../Common/components/Alert";
import { Mui } from "@osu/react-ui";

const SkeletonIcon = ({ className }) => (
  <Mui.Skeleton
    variant="circular"
    width={"2.75rem"}
    height={"2.75rem"}
    className={className}
  />
);

const Loading = () => [...Array(3)].map((empty, idx) => {
  return (
    <Mui.Box key={"quick-links-validation-skeleton" + idx} className="margin-2 display-flex width-100">
      <SkeletonIcon className="margin-right-1" />
      <SkeletonIcon className="margin-right-1" />
      <Mui.Skeleton className="margin-x-2" width={'50%'} />
      <SkeletonIcon className="margin-left-auto margin-right-5" />
    </Mui.Box>
  );
})

function Validator({
  children,
  errorMessage,
  infoMessage,
  successMessage,
  isLoading,
  alertRef
}) {
  let alertProps = {
    className: "margin-top-1"
  };
  
  if (errorMessage) {
    alertProps.severity = "error";
    alertProps.description = errorMessage;
  } else if (infoMessage) {
    alertProps.severity = "info";
    alertProps.description = infoMessage;
  } else if (successMessage) {
    alertProps.severity = "success";
    alertProps.description = successMessage;
  }

  return (
    <Fragment>
      <Alert {...alertProps} ref={alertRef} />
      {isLoading ? <Loading /> : children}
    </Fragment>
  );
}

export default Validator;
